import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * Export Class
 */
export class AccountService {
  public account;
  public authorization;
  public addressValidation;
  public wallet;
  public searchPipe = new BehaviorSubject(false);
  public isRegulated = new BehaviorSubject( false,);
  public walletObserve: Observable<{
    status: boolean;
  }>
  public searchPipeObserve: Observable<boolean>;
  public authValidationsObserve: Observable<boolean>
  public isRegulatedObserve: Observable<boolean>;
  public authorizationObserve: Observable<{
    status: boolean;
  }>
  public authValidations = new BehaviorSubject(false);
  public accountObserve: Observable<{
    address: string,
    chainId: string,
    network: string,
  }>;

  public addressValidationObserve: Observable<{
    address: any;
  }>

  /**
   * Constructor
   */
  constructor(
  ) {
    this.wallet = new BehaviorSubject({
      status: false,
    });
    this.walletObserve = this.wallet.asObservable();

    this.searchPipeObserve = this.searchPipe.asObservable();
    this.isRegulatedObserve = this.isRegulated.asObservable();
    
    this.authValidationsObserve = this.authValidations.asObservable();

    this.account = new BehaviorSubject(false);
    this.accountObserve = this.account.asObservable();
    this.authorization = new BehaviorSubject({
      status: false,
    });
    this.authorizationObserve = this.authorization.asObservable();

    this.addressValidation = new BehaviorSubject({
      address: '',
    });
    this.addressValidationObserve = this.addressValidation.asObservable();
  }

  /**
   * Set Account
   * @param {boolean}  data
   */
  public accountChange(data) {
    this.account.next(data);
  }

  /**
   * Check Authorization
   * @param {object} data
   */
  public checkAuthorization(data: {
    status: boolean,
  }) {
    this.authorization.next(data);
  }

  /**
   * Check Address
   * @param {object} data
   */
  public checkAddress(data: {
    address: string,
  }) {
    this.addressValidation.next(data);
  }

  /**
   * Check Address
   * @param {object} data
   */
  public openWallet(data: {
    status: any,
  }) {
    this.wallet.next(data);
  }


  /**
   * Searchs pipe update
   * @param {boolean} data 
   */
  public searchPipeUpdate(data:boolean) {
    this.searchPipe.next(data);
  }

  /**
   * Auths validations update
   * @param {boolean} data 
   */
  public authValidationsUpdate(data:boolean) {
    this.authValidations.next(data);
  }

  /**
   * Changes regulated
   * @param {boolean} data 
   */
  public changeRegulated(data: boolean) {
    this.isRegulated.next(data);
  }

}
